import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'
import queryString from 'query-string'
import { Form as UnstyledForm } from 'formsy-react-2'
import R from 'ramda'
import { Button as OriginalButton, Colors, ContextMenu, Link, ModalRemove, ModalSave,
  Table, TableCell, TableHeader, TableLoading, TextIcon, Title, Pagination, TextInput } from 'advenio-components'
import CompaniesActions from '@redux/CompaniesRedux'
import CountriesActions from '@redux/CountriesRedux'
import { userHasRole } from 'utils/Utils'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
  padding: 8px 24px;
  box-sizing: border-box;
`
const Button = styled(OriginalButton).attrs({
  marginRight: '0',
})`
  margin-left: auto;
`
const TableContainer = styled.div`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
  box-sizing: border-box;
  border-radius: 5px;
  overflow: hidden;
`
const Pill = styled.span`
  padding: 4px 16px;
  background-color: ${({ active }) => active ? Colors.green500 : Colors.red500};
  border-radius: 20px;
  color: #FFF;
`
const HeadersContainer = styled.div`
  width: 100%;
  display: inline-flex;
`

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
`
const Form = styled(UnstyledForm)`
  display: inline-block;
  flex-direction: column;
  width: 107%;
  margin-left: 33%;
`
const InputContainer = styled.div`
    margin-right: 5px;
    width: 50%;
`

const Send = styled.div`
  width: 60%;
  height: auto;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 20px;
`

const PaginationContainer = styled.div`
  width: 50%;
  padding: 32px 0;
`

const FormContainer = styled.div`
  width: 50%;
`

class Companies extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataToBeRemoved: {},
      modalRemoveOpened: false,
      modalSaveOpened: false,
      selectedCountryIndex: 0,
      page: 1,
      queryParams: {},
    }
  }

  componentWillMount() {
    const queryParams = queryString.parse(this.props.location.search)
    const { getCompanies, getCountries, getPaymentTypes } = this.props
    if (queryParams.page) {
      this.setState({ pageSelected: parseInt(queryParams.page) })
    }
    this.setState({ queryParams })
    getCompanies(queryParams)
  }

  onAddCompany = () => this.setState({ modalSaveOpened: true })

  onChangeCountry = event => this.setState({ selectedCountryIndex: event.target.selectedIndex })

  onCloseModalSave = () => this.setState({ modalSaveOpened: false })

  onCloseModalRemove = () => this.setState({ modalRemoveOpened: false })

  buildCenterOptions = () => {
    const { countries } = this.props
    return countries.length ? countries[this.state.selectedCountryIndex].centers : []
  }

  removeCompany = data => () => this.setState({
    dataToBeRemoved: data,
    modalRemoveOpened: true,
  })

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { goTo, getCompanies } = this.props

      const queries = { ...queryParams, page }
      getCompanies(queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onFilter = (query) => {
    const queries = R.clone(query)
    const { goTo, getCompanies } = this.props
    Object.keys(queries).forEach((value) => {
      if (!query[value]) {
        delete queries[value]
      }
    })
    this.setState({ queryParams: queries })
    goTo(`?${queryString.stringify(queries)}`)
    getCompanies(queries)
  }

  restoreCompany = id => () => this.props.restoreCompany(id)

  navigateToCompanyProfile = id => () => this.props.goToCompanyProfile(id)

  render() {
    const { companies, countries, loading, meta, users, user } = this.props
    const { dataToBeRemoved, modalRemoveOpened, modalSaveOpened, pageSelected, queryParams } = this.state

    return (
      <Container>
        <HeaderRow>
          <Title>Empresas</Title>
          {!userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) && (
            !loading && (
              <Button primary disabled={loading} onClick={this.onAddCompany}>
                <TextIcon label="Agregar Empresa" iconType="plus" iconViewBox="-2 -2 24 24" />
              </Button>
            ))
          }
        </HeaderRow>
        <TableContainer>
          <HeadersContainer>
            <PaginationContainer>
              <Pagination
                totalElements={meta && meta.total}
                elementsPerPage={meta && meta.per_page}
                onPageClick={this.onClickPage}
                pageSelected={pageSelected}
              />
            </PaginationContainer>
            <FormContainer>
              <Form onSubmit={this.onFilter}>
                <FiltersContainer>
                  <InputContainer>
                    <TextInput
                      name="name"
                      label="Nombre de la Compañia"
                      value={queryParams.name || ''}
                    />
                  </InputContainer>
                  <Send>
                    <Button marginRight="70%" width="21%" loading={loading} primary small type="submit">Filtrar</Button>
                  </Send>
                </FiltersContainer>
              </Form>
            </FormContainer>
          </HeadersContainer>
          {loading && (
            <TableLoading
              curvedTop
              columns={[
                {
                  id: 1,
                  header: 'Empresa',
                  element: 'Text',
                },
                {
                  id: 2,
                  header: 'Convenios',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: 'Lugares',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 4,
                  header: 'Ocupados',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: 'Reservados',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 6,
                  header: 'Disponibles',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 7,
                  header: 'Status',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
          )}
          {!loading && (
            <Table
              roundedCorners
              withBorder
              borderColor="#ddd"
              data={companies}
              columns={[
                {
                  Header: () => <TableHeader title="Empresa" blue />,
                  id: 'name',
                  accessor: ({ id, name }) => ({ id, name }),
                  Cell: ({ value: { id, name }, index }) =>
                    (<TableCell index={index}>
                      <Link onClick={this.navigateToCompanyProfile(id)}>{name}</Link>
                    </TableCell>),

                  // sortMethod: (a, b) => {
                  //   let { name: nameA } = a
                  //   let { name: nameB } = b
                  //   // force null and undefined to the bottom
                  //   nameA = (nameA === null || nameA === undefined) ? -Infinity : nameA
                  //   nameB = (nameB === null || nameB === undefined) ? -Infinity : nameB
                  //   // force any string values to lowercase
                  //   nameA = nameA === 'string' ? nameA.toLowerCase() : nameA
                  //   nameB = nameB === 'string' ? nameB.toLowerCase() : nameB
                  //   // Return either 1 or -1 to indicate a sort priority
                  //   if (nameA > nameB) {
                  //     return 1
                  //   }
                  //   if (nameA < nameB) {
                  //     return -1
                  //   }
                  //   // returning 0, undefined or any falsey value will use subsequent sorts
                  //   // or the index as a tiebreaker
                  //   return 0
                  // },
                },
                {
                  Header: () => <TableHeader title="Convenios" center blue />,
                  id: 'contracts',
                  accessor: 'contracts_count',
                  width: 180,
                  Cell: ({ value, index }) => <TableCell index={index} center>{value}</TableCell>,
                },
                {
                  Header: () => <TableHeader title="Lugares" center blue />,
                  id: 'placesTotal',
                  accessor: 'places_total_count',
                  width: 180,
                  Cell: ({ value, index }) => <TableCell index={index} center>{value}</TableCell>,
                },
                {
                  Header: () => <TableHeader title="Ocupados" center blue />,
                  id: 'placesOccupied',
                  accessor: 'places_occupied_count',
                  width: 180,
                  Cell: ({ value, index }) => <TableCell index={index} center>{value}</TableCell>,
                },
                {
                  Header: () => <TableHeader title="Reservados" center blue />,
                  id: 'placesReserved',
                  accessor: 'places_reserved_count',
                  width: 180,
                  Cell: ({ value, index }) => <TableCell index={index} center>{value}</TableCell>,
                },
                {
                  Header: () => <TableHeader title="Disponibles" center blue />,
                  id: 'placesAvailable',
                  accessor: 'places_available_count',
                  width: 180,
                  Cell: ({ value, index }) => <TableCell index={index} center>{value}</TableCell>,
                },
                {
                  Header: () => <TableHeader title="Status" center blue />,
                  id: 'deletedAt',
                  accessor: 'deleted_at',
                  width: 200,
                  Cell: ({ value, index }) => (
                    <TableCell index={index} center>
                      {value ? (<Pill>Inactivo</Pill>) : (<Pill active>Activo</Pill>)}
                    </TableCell>
                  ),
                },
                {
                  Header: '',
                  id: 'createdAt',
                  accessor: 'created_at',
                  width: 0,
                },
                {
                  Header: () => <TableHeader blue />,
                  id: 'contextMenu',
                  accessor: data => data,
                  width: !userHasRole(user, ['Receptionist', 'Director', 'Coordinator']) ? 90 : 0,
                  sortable: false,
                  Cell: ({ value: data, index }) => {
                    const { id: companyId } = data
                    const elements = [
                      {
                        id: 1,
                        icon: 'edit',
                        label: 'Editar',
                        onClick: this.navigateToCompanyProfile(companyId),
                      },
                    ]

                    if (data.deleted_at) {
                      elements.push({
                        id: 2,
                        icon: 'plus',
                        label: 'Dar de alta',
                        onClick: this.restoreCompany(companyId),
                      })
                    } else {
                      elements.push({
                        id: 3,
                        icon: 'remove',
                        label: 'Dar de baja',
                        onClick: this.removeCompany({ id: companyId, name: data.name }),
                      })
                    }

                    return (
                      <TableCell index={index} center>
                        <ContextMenu value={data} elements={elements} />
                      </TableCell>
                    )
                  },
                },
              ]}
              // defaultSorted={[{
              //   id: 'createdAt',
              //   desc: true,
              // }]}
              // defaultPageSize={10}
            />
          )}
        </TableContainer>
        {!loading && (
          <ModalSave
            isOpened={modalSaveOpened}
            titleItem="empresa"
            statePath="companies"
            typePrefix="COMPANIES"
            type="create"
            onClose={this.onCloseModalSave}
            fields={[
              {
                name: 'name',
                label: 'Nombre',
                path: 'name',
                type: 'input',
                required: true,
                validations: 'maxLength:255',
                colMd: 12,
                colSm: 12,
              },
              {
                name: 'country_id',
                label: 'País',
                path: 'country_id',
                type: 'simpleSelect',
                required: true,
                options: countries,
                optionsValue: 'id',
                optionsLabel: 'name',
                onChangeCallback: this.onChangeCountry,
                colMd: 4,
                colSm: 4,
              },
              {
                name: 'attend',
                label: '¿Quién lo Atiende?',
                path: 'attend',
                type: 'simpleSelect',
                required: true,
                options: users,
                optionsValue: 'id',
                optionsLabel: 'name',
                colMd: 8,
                colSm: 8,
              },
              {
                name: 'requires_invoices',
                label: 'Requiere Facturas',
                path: 'requires_invoices',
                type: 'checkbox',
                inputAlign: true,
                large: true,
                invertedColors: true,
                value: true,
              },
              {
                name: 'with_retention',
                label: 'Requiere Retención de IVA',
                path: 'with_retention',
                type: 'checkbox',
                inputAlign: true,
                large: true,
                invertedColors: true,
                value: true,
                colMd: 8,
                colSm: 8,
              },
              // {
              //   name: 'center_ids',
              //   label: 'Centros asociados',
              //   path: 'center_ids',
              //   type: 'tags',
              //   required: true,
              //   options: this.buildCenterOptions(),
              //   optionsValue: 'id',
              //   optionsLabel: 'name',
              //   colMd: 12,
              //   colSm: 12,
              // },
            ]}
          />
        )}
        <ModalRemove
          requiresConfirmationInput
          feminineTitleItem
          isOpened={modalRemoveOpened}
          onClose={this.onCloseModalRemove}
          titleItem="empresa"
          statePath="companies"
          typePrefix="COMPANIES"
          toRemoveData={dataToBeRemoved}
        />
      </Container>
    )
  }
}

Companies.propTypes = {
  loading: PropTypes.bool.isRequired,
  getCompanies: PropTypes.func.isRequired,
  goToCompanyProfile: PropTypes.func.isRequired,
  countries: PropTypes.array.isRequired,
  getCountries: PropTypes.func.isRequired,
  restoreCompany: PropTypes.func.isRequired,
}

Companies.defaultProps = {
}

const mapStateToProps = ({ companies, countries, users, ...state }) => ({
  loading: companies.get.fetching || countries.get.fetching,
  companies: companies.get.results.data,
  countries: countries.get.results,
  meta: companies.get.results.meta,
  users: users.get.results,
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
  getCompanies: query => dispatch(CompaniesActions.getRequest(query)),
  getPaymentTypes: () => dispatch(CompaniesActions.getPaymentTypesRequest()),
  getCountries: () => dispatch(CountriesActions.getRequest()),
  goToCompanyProfile: id => dispatch(push(`/companies/${id}`)),
  restoreCompany: id => dispatch(CompaniesActions.restoreRequest(id)),
  goTo: path => dispatch(push(path)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Companies))



// WEBPACK FOOTER //
// ./src/Containers/Companies/Companies.jsx